module.exports = __webpack_public_path__ + "static/card_swip-c8ad1d7607566c81a8580924674efeac.jpg";